import { theme, ThemeConfig } from 'antd';
import { 
  PDF_COLOR_TEXT,
  PDF_COLOR_ERROR,
  PDF_COLOR_BG_SHADED,
  PDF_FONT_SIZE_BASE,
  PDF_BORDER_RADIUS,
  PDF_BORDER_RADIUS_LG,
  PDF_FONT_WEIGHT_STRONG,
  PDF_FORM_ITEM_MARGIN_BOTTOM,
  PDF_FORM_VERTICAL_LABEL_PADDING,
  PDF_CASCADER_DROPDOWN_HEIGHT,
  PDF_HIDE,
  PDF_COLOR_TEXT_SECONDARY,
  PDF_COLOR_BACKGROUND,
} from '#types/System.Themes.types';

export type ExportThemeConfig = ThemeConfig & {
  pdfFormat?: boolean;
};

/** Theme configuration specifically for light mode exports */
export const exportThemeConfig: ExportThemeConfig = {
  pdfFormat: true,
  algorithm: theme.defaultAlgorithm,
  token: {
    fontFamily: "'Work Sans', sans-serif",
    fontSize: parseInt(PDF_FONT_SIZE_BASE),
    fontWeightStrong: PDF_FONT_WEIGHT_STRONG,
    borderRadius: PDF_BORDER_RADIUS,
    borderRadiusLG: PDF_BORDER_RADIUS_LG,
    motion: false,
    motionUnit: 0,
    colorPrimary: PDF_HIDE,
    colorLink: PDF_HIDE,
    colorPrimaryBorder: PDF_HIDE,
    colorInfo: PDF_HIDE,
    colorFillTertiary: PDF_COLOR_BG_SHADED,
    colorFill: PDF_COLOR_BG_SHADED,
    colorFillSecondary: PDF_COLOR_BG_SHADED,
    colorText: PDF_COLOR_TEXT,
    colorTextDisabled: PDF_COLOR_TEXT,
    colorTextLightSolid: PDF_COLOR_TEXT,
    colorTextSecondary: PDF_COLOR_TEXT_SECONDARY,
    colorTextTertiary: PDF_COLOR_TEXT,
    colorTextQuaternary: PDF_COLOR_TEXT,
    colorBorderBg: PDF_HIDE,
    colorBorder: PDF_HIDE,
    colorBgTextActive: PDF_COLOR_BG_SHADED,
    colorError: PDF_COLOR_ERROR,
    colorBgContainer: PDF_COLOR_BACKGROUND,
    colorBgLayout: PDF_COLOR_BG_SHADED,
    colorBgBase: PDF_COLOR_BACKGROUND,
    colorBgSolid: PDF_COLOR_BG_SHADED,
    colorTextPlaceholder: PDF_HIDE,
    // ArTable-specific tokens - must be grayscale for PDF export
    colorBgElevated: PDF_COLOR_BG_SHADED,
    colorFillQuaternary: PDF_COLOR_BG_SHADED,
    colorPrimaryBg: PDF_COLOR_BACKGROUND,
  },
  components: {
    Button: {
      controlOutlineWidth: 0,
      boxShadowTertiary: "none",
      colorPrimary: PDF_HIDE,
      colorBgContainer: PDF_HIDE,
      defaultColor: PDF_HIDE,
      colorText: PDF_HIDE,
      colorBorder: PDF_HIDE,
      borderColorDisabled: PDF_HIDE,
      colorLink: PDF_HIDE,
      colorTextLightSolid: PDF_HIDE,
    },
    Segmented: {
      itemSelectedBg: PDF_COLOR_BG_SHADED,
    },
    Radio: {
      buttonCheckedBg: PDF_COLOR_BG_SHADED,
    },
    Modal: {
      contentBg: PDF_COLOR_BG_SHADED,
      headerBg: PDF_COLOR_BG_SHADED,
    },
    Form: {
      verticalLabelPadding: PDF_FORM_VERTICAL_LABEL_PADDING,
      itemMarginBottom: PDF_FORM_ITEM_MARGIN_BOTTOM
    },
    Cascader: {
      dropdownHeight: PDF_CASCADER_DROPDOWN_HEIGHT
    },
    Upload: {
      colorFill: PDF_HIDE,
      colorBorder: PDF_HIDE,
      colorText: PDF_HIDE,
      colorTextDisabled: PDF_HIDE,
      colorBgContainer: PDF_HIDE,
      colorPrimary: PDF_HIDE,
    },
    Select: {
      colorBgContainerDisabled: PDF_COLOR_BG_SHADED,
      colorBgContainer: PDF_COLOR_BG_SHADED,
      colorBorder: PDF_HIDE,
      colorPrimaryHover: PDF_HIDE,
      optionSelectedBg: PDF_COLOR_BG_SHADED,
    },
    Input: {
      colorText: PDF_COLOR_TEXT,
      colorTextPlaceholder: PDF_HIDE,
      colorBgContainer: PDF_COLOR_BG_SHADED,
      colorBgContainerDisabled: PDF_COLOR_BG_SHADED,
      colorBorder: PDF_HIDE,
      colorBorderSecondary: PDF_HIDE,
      colorBorderBg: PDF_HIDE,
      activeBorderColor: PDF_HIDE,
      hoverBorderColor: PDF_HIDE,
    },
    InputNumber: {
      colorBorder: PDF_HIDE,
      colorBorderSecondary: PDF_HIDE,
      activeBorderColor: PDF_HIDE,
      hoverBorderColor: PDF_HIDE,
      colorBgContainer: PDF_COLOR_BG_SHADED,
      colorBgContainerDisabled: PDF_COLOR_BG_SHADED,
    },
    DatePicker: {
      colorBorder: PDF_HIDE,
      activeBorderColor: PDF_HIDE,
      hoverBorderColor: PDF_HIDE,
      colorBgContainer: PDF_COLOR_BG_SHADED,
      colorBgContainerDisabled: PDF_COLOR_BG_SHADED,
    },
    Checkbox: {
      colorBorder: PDF_COLOR_TEXT_SECONDARY,
      colorPrimary: PDF_COLOR_TEXT,
      colorPrimaryHover: PDF_COLOR_TEXT,
    },
    Tag: {
      colorBorder: PDF_HIDE,
    },
    Switch: {
      colorPrimary: PDF_COLOR_TEXT,
      colorPrimaryHover: PDF_COLOR_TEXT,
    },
    Table: {
      headerBg: PDF_HIDE,
      footerBg: PDF_HIDE,
      colorBgBase: PDF_HIDE,
      colorBgContainer: PDF_HIDE,
    }
  },
}; 